
import { connect } from 'react-redux';

import Translatable from 'reactlang.js';

import { errorsActions } from '../../actions';

import { getLang } from '../../selectors';

const mapStateToProps = state => ({
    lang: getLang(state)
});

const mapDispatchToProps = dispatch => ({
    handleError: error => dispatch(errorsActions.addError(error))
});

export default connect(mapStateToProps, mapDispatchToProps)(Translatable);

export {
    Translatable as DisconnectedTranslatable
};



// WEBPACK FOOTER //
// ./src/components/Translatable/Translatable.jsx